import { render, staticRenderFns } from "./CotPropostaAccessoListaAttesaComponent.vue?vue&type=template&id=9ed5b6fe"
import script from "./CotPropostaAccessoListaAttesaComponent.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoListaAttesaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports